import React, { useEffect, useState, useContext } from 'react'

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CardHeader from '@mui/material/CardHeader';
import { LanguageContext } from "App";
import { useLocation } from 'react-router-dom';
import SearchDayBar from './AppointmentDays/SearchDayBar';
import AppointmentDayCard from './AppointmentDays/AppointmentDayCard';
import AppointmentsApi from "../../Classes/API/Appointments/AppointmentsApi";
import GetAppointmentDayReq from '../../Classes/Models/Requests/Appointments/GetAppointmentDayReq';

import Swal from 'sweetalert2';


const index = () => {
  const { state } = useLocation();
  const {translations} = useContext(LanguageContext)
  const [IsLoaded, setIsLoaded] = useState(false)
  const [AppDay, setAppDay] = useState(new Date())

  const GetAppDay = async (SearchDay) => {
    let req = new GetAppointmentDayReq();
    req.dateDay = SearchDay
    //todo
    req.dateDay.setHours(12, 0, 0, 0);

    let res = await AppointmentsApi.GetAppoinmentDayByDate(req);

    if (res.status == "Success") {
      setAppDay(res.data)
    }
    else {
      Swal.fire("Failed", res.message, "error");
    }
  }

  useEffect(() => {
    if (Object.keys(AppDay).length > 0) {
      setIsLoaded(true)
    }

  }, [AppDay])
  return (
    <DashboardLayout>
      <CardHeader className="mb-2" title={translations.Appointments}></CardHeader>

      <div className="card">
        <div className="card-body">
          <div className="container-fluid" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <h5>{translations.appointmentSelectDay}</h5>
                <SearchDayBar GetAppDay={GetAppDay} />
          </div>
        </div>
      </div>

      <div>
        {
          IsLoaded ?
            <div className="card mt-4">
              <div className="card-body">
                <AppointmentDayCard AppDay={AppDay} />
              </div>
            </div>
            : null  
        }
      </div>

    </DashboardLayout>
  )

}

export default index